import colors from 'styles/colors';
import { SVGComponentPropsType } from './types';

export default ({ color = colors.green, ...props }: Omit<SVGComponentPropsType, 'size'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" {...props}>
    <defs>
      <path id="reported-odometer-icon-path" d="m12 17-4-4 7.5-5.5 2-2.5V0H0v17z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <mask id="reported-odometer-icon-mask" fill="#fff">
          <use xlinkHref="#reported-odometer-icon-path" />
        </mask>
        <path
          d="M9 2a8 8 0 0 1 6.2 13H2.8A8 8 0 0 1 9 2Z"
          stroke="#9DA1AA"
          strokeWidth="2"
          mask="url(#reported-odometer-icon-mask)"
        />
        <g mask="url(#reported-odometer-icon-mask)" stroke="#9DA1AA" strokeWidth="2">
          <path d="M1 10h3M9 5V2M5.5 6.5l-2-2M12.5 6.5l2-2" />
        </g>
      </g>
      <path fill={color} fillRule="nonzero" d="M20.4 5 22 6.5 13.6 16 9 11.1l1.5-1.6 3 3.2z" />
    </g>
  </svg>
);
